import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';
import ForgotPasswordForm from './ForgotPasswordForm';

export default function AuthModal({ isOpen, onClose, onAuthSuccess, initialMode = 'login' }) {
  const [mode, setMode] = useState(initialMode);
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleClose = () => {
    if (!loading) {
      onClose();
      setMode('login');
    }
  };

  const handleAuthSuccess = () => {
    if (!loading) {
      onClose();
      setMode('login');
      if (onAuthSuccess) {
        onAuthSuccess();
      }
    }
  };

  const modalContent = () => {
    switch (mode) {
      case 'signup':
        return (
          <SignupForm
            onSuccess={handleAuthSuccess}
            onSwitchToLogin={() => setMode('login')}
            loading={loading}
            setLoading={setLoading}
          />
        );
      case 'forgot':
        return (
          <ForgotPasswordForm
            onBack={() => setMode('login')}
            loading={loading}
            setLoading={setLoading}
          />
        );
      default:
        return (
          <LoginForm
            onSuccess={handleAuthSuccess}
            onSwitchToSignup={() => setMode('signup')}
            onForgotPassword={() => setMode('forgot')}
            loading={loading}
            setLoading={setLoading}
          />
        );
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'var(--bg-modal-overlay)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'var(--bg-secondary)',
        borderRadius: '12px',
        boxShadow: 'var(--shadow-lg)',
        maxWidth: '400px',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
        position: 'relative'
      }}>
        {/* Close button */}
        <button
          onClick={handleClose}
          disabled={loading}
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: loading ? 'not-allowed' : 'pointer',
            color: 'var(--text-secondary)',
            padding: '5px',
            borderRadius: '50%',
            width: '35px',
            height: '35px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: loading ? 0.5 : 1
          }}
          title="Close"
        >
          ×
        </button>

        {modalContent()}
      </div>
    </div>
  );
}